import Vue from 'vue';
import request from './untils/request';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router'
import './untils/fexilb'
//引入echarts
import * as echarts from 'echarts'
//引入vue-echarts
import VueEcharts from 'vue-echarts'
import store from './store';
//注册为全局组件
Vue.component('v-chart', VueEcharts)

Vue.prototype.$request = request;
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  el: '#app',
	store, // 将Vuex Store注入到Vue应用中
	router,
	render: h => h(App)
}).$mount('#app')
